import { mapActions, mapGetters } from 'vuex';
import CoursInscriptionMixin from '@/pages/Cours/CoursInscription.mixin';
import { DateTime } from 'luxon';

/**
 * @property classType - Nom de la catégorie de cours à afficher.
 */
export default {

  async mounted() {
    await this.getClasses();
  },

  mixins: [ CoursInscriptionMixin ],

  computed: {
    ...mapGetters('services', {
      classes: 'classes'
    }),

    /**
     * Return the list of classes for this type.
     * Sorted by availability.
     *
     * @returns []
     */
    cours() {
      const sortFn = (a, b) => {
        if (a.date && !b.date) {
          return -1;
        }
        const aDate = DateTime.fromISO(a.date);
        const bDate = DateTime.fromISO(b.date);
        if (aDate.equals(bDate)) {
          return 0;
        }
        return aDate < bDate ? -1 : 1;
      };

      // We want to split it in two array. One where the classes are open, the other where the registrations are closed.
      return this.classes
        .filter(c => c.type === this.classType)
        .filter(c => c.date !== null)
        .sort(sortFn)
        .reverse();
    }
  },
  methods: {
    ...mapActions('services', {
      getClasses: 'fetchServices'
    })
  }
};
